import { Map, List, Set } from 'immutable'
import {
  SET_EVENT_SERIES_IMPRESSED,
} from 'services/event-tracking/actions'
import {
  setMultipleSeries as setMultipleSeriesAction,
  setMultipleSeriesProcessing as setMultipleSeriesProcessingAction,
  setSeries as setSeriesAction,
  setSeriesError as setSeriesErrorAction,
  setSeriesImpressionData as setSeriesImpressionDataAction,
  GET_MULTIPLE_PM_SERIES,
  GET_PM_SERIES,
} from './actions'
import {
  getMany as getManySeries,
  get as getSeries,
} from '.'

/**
 * Get multiple series and dispatch associated actions
 * @param {Object} options The options
 * @param {import('redux').Dispatch} options.dispatch Redux dispatch function
 * @param {Map} options.auth The auth state
 * @param {Number[]|List|Set} options.seriesIds The series ids
 * @param {String} options.language The request language
 */
export async function getSeriesMultiple (options = {}) {
  const { dispatch, auth = Map(), language } = options
  let { seriesIds = [] } = options
  if (List.isList(seriesIds) || Set.isSet(seriesIds)) {
    seriesIds = seriesIds.toArray()
  }
  try {
    const pmSeries = await getManySeries(seriesIds, { auth, language })
    dispatch(setMultipleSeriesAction(seriesIds, language, pmSeries))
  } catch (e) {
    // Do Nothing
    dispatch(setMultipleSeriesProcessingAction(seriesIds, language, false))
  }
}

/**
 * Get one series and dispatch associated actions
 * @param {Object} options The options
 * @param {import('redux').Dispatch} options.dispatch Redux dispatch function
 * @param {Map} options.auth The auth state
 * @param {Number} options.seriesId The series id
 * @param {String} options.language The request language
 */
export async function getSeriesSingle (options = {}) {
  const { dispatch, auth, seriesId, language } = options
  try {
    const pmSeries = await getSeries(seriesId, { auth, language })
    dispatch(setSeriesAction(seriesId, language, pmSeries))
  } catch (e) {
    dispatch(setSeriesErrorAction(seriesId, language, e))
  }
}

async function handleSeriesImpression (dispatch, actionPayload) {
  const { event, language } = actionPayload
  const seriesId = event.getIn(['properties', 'contentId'])
  dispatch(setSeriesImpressionDataAction(seriesId, language.get(0)))
}

export default function middleware (store) {
  return next => (action) => {
    const { dispatch } = store
    const { auth = Map() } = store.getState()
    switch (action.type) {
      case GET_MULTIPLE_PM_SERIES: {
        const { seriesIds, language } = action.payload
        getSeriesMultiple({
          dispatch, auth, seriesIds, language,
        })
        break
      }
      case GET_PM_SERIES: {
        const { seriesId, language } = action.payload
        getSeriesSingle({
          dispatch, auth, seriesId, language,
        })
        break
      }
      case SET_EVENT_SERIES_IMPRESSED:
        handleSeriesImpression(dispatch, action.payload)
        break
      default:
        break
    }
    next(action)
  }
}
